<div cdkDrag cdkDragRootElement=".modal-dialog">
<div class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header" cdkDragHandle>
    <div class="p-2 modal-title"><h5>{{_pathTestDoc.type|titlecase}} - Scheduling</h5></div>
    <button class="p-0 m-0 btn" style="line-height: .8; color: white" (click)="onCancel()" aria-label="Close">
        <i class="fa fa-window-close"></i>
    </button>
</div>

<div class="container-fluid busy-overlay-parent p-3" [ngClass]="bProcessing?'disabled':''">
    <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Please wait...
    </div>
    <form #pathTestForm="ngForm" class="card p-2">
        <div *ngIf="errorMsg" class="alert alert-danger mb-3">{{errorMsg|shorten:120:'...'}}</div>
        <div class="input-group input-group-sm">
            <div class="p-2">
                <label for="stageSelect" class="form-label">Stage:</label>
                <select name="stage" class="form-control" id="stageSelect"
                    [(ngModel)]="tmpPathTest.stage" #stageSelect="ngModel" required
                    [ngClass]="{ 'invalid-input': stageSelect.invalid && (stageSelect.dirty || stageSelect.touched)}">
                    <option *ngFor="let stage of stages" [ngValue]="stage">{{stage}}</option>
                </select>
                <span *ngIf="stageSelect.invalid" class="text-danger small font-italic">* Required</span>
            </div>
            <div class="p-2" *ngIf="_pathTestDoc.type === 'path test'">
                <label for="buildingIdSelect" class="form-label">Building:</label>
                <select name="buildingId" class="form-control" id="buildingIdSelect"
                    [disabled] = "!!tmpPathTest._id"
                    #buildingIdSelect="ngModel" required
                    [(ngModel)]="tmpPathTest.buildingId" (ngModelChange)="onBuildingIdChanged($event)"
                    [ngClass]="{ 'invalid-input': buildingIdSelect.invalid && (buildingIdSelect.dirty || buildingIdSelect.touched)}">
                    <option *ngFor="let buildingInfo of buildingInfoArray" [ngValue]="buildingInfo.id">{{buildingInfo.id}} - {{buildingInfo.name}}</option>
                </select>
                <span *ngIf="buildingIdSelect.invalid" class="text-danger small font-italic">* Required</span>
            </div>

            <div class="p-2" *ngIf="_pathTestDoc.type === 'drive test'">
                <label for="routeIdSelect" class="form-label">Route:</label>
                <select name="routeId" class="form-control" id="routeIdSelect"
                    [disabled] = "!!tmpPathTest._id"
                    #routeIdSelect="ngModel" required
                    [(ngModel)]="tmpPathTest.routeId"
                    [ngClass]="{ 'invalid-input': routeIdSelect.invalid && (routeIdSelect.dirty || routeIdSelect.touched)}">
                    <option *ngFor="let routeInfo of routeInfoArray" [ngValue]="routeInfo.id">{{routeInfo.id}} - {{routeInfo.market}}</option>
                </select>
                <span *ngIf="routeIdSelect.invalid" class="text-danger small font-italic">* Required</span>
            </div>

            <div class="p-2 w-25">
                <label for="cycleInput" class="form-label">Cycle:</label>
                <input type="number" size="2" name="cycle" class="form-control" id="cycleInput"
                    [(ngModel)]="tmpPathTest.cycle" #cycleInput="ngModel" required
                    [ngClass]="{ 'invalid-input': cycleInput.invalid && (cycleInput.dirty || cycleInput.touched)}">
                <span *ngIf="cycleInput.invalid" class="text-danger small font-italic">* Required</span>
            </div>
            <div class="p-2" *ngIf="_pathTestDoc.type === 'path test'">
                <label for="cycleInput" class="form-label">Grouping Field:</label>
                <input type="text" name="groupingfield" class="form-control" id="groupingFieldInput"
                    [(ngModel)]="tmpPathTest.groupingfield" #groupingFieldInput="ngModel"
                >
            </div>

            <div class="p-2 d-flex flex-row w-100" *ngIf="_pathTestDoc.type === 'path test'">
                <div class="w-100 pr-3">
                    <label for="pathIdSelect" class="form-label">
                        Path ID:&nbsp;<i *ngIf="bLoadingPathIds" class="fa fa-spinner fa-spin small"></i>
                    </label>
                    <div>
                        <select name="pathId" class="form-control" style="display: inline-block" id="pathIdSelect"
                            [disabled] = "!!tmpPathTest._id||!tmpPathTest.buildingId||bLoadingPathIds"
                            #pathIdSelect="ngModel" required
                            [(ngModel)]="tmpPathTest.pathId" (ngModelChange)="onPathIdChanged($event)"
                            [ngClass]="{ 'invalid-input': pathIdSelect.invalid && (pathIdSelect.dirty || pathIdSelect.touched)}">
                            <option *ngFor="let pathId of pathIds" [ngValue]="pathId">
                                {{pathId}}
                            </option>
                        </select>
                    </div>
                    <div *ngIf="!bLoadingPathIds" class="m-0 p-0 text-danger small font-italic">
                        <div *ngIf="tmpPathTest.buildingId&&!pathIds?.length; else checkInvalidPathId">
                            * Path(s) not found for building <b>{{tmpPathTest.buildingId}}</b>
                        </div>
                        <ng-template #checkInvalidPathId>
                            <div *ngIf="pathIdSelect.invalid">
                                * Required
                            </div>
                        </ng-template>
                    </div>
                </div>
                <div>
                    <label for="orderInput" class="form-label">Test Order:</label>
                    <input type="number" size="2" name="order" class="form-control" id="orderInput"
                        [(ngModel)]="tmpPathTest.order" #orderInput="ngModel"
                        [ngClass]="{ 'invalid-input': orderInput.invalid && (orderInput.dirty || orderInput.touched)}">
                </div>
            </div>

            <div class="p-2">
                <label for="scheduleDateInput" class="form-label">Schedule Date:</label>
                <input type="date" name="scheduleDate" class="form-control" id="scheduleDateInput"
                    [(ngModel)]="tmpPathTest.schedule.scheduledDate" #scheduleDateInput="ngModel" required
                    [ngClass]="{ 'invalid-input': scheduleDateInput.invalid && (scheduleDateInput.dirty || scheduleDateInput.touched)}">
                <span *ngIf="scheduleDateInput.invalid" class="text-danger small font-italic">* Required</span>
            </div>

            <div class="p-2">
                <label for="scheduleUserSelect" class="form-label">Scheduler:</label>
                <select name="scheduleUser" class="form-control" id="scheduleUserSelect"
                    [(ngModel)]="tmpPathTest.assignments.scheduleUserId" #scheduleUserSelect="ngModel" required
                    [ngClass]="{ 'invalid-input': scheduleUserSelect.invalid && (scheduleUserSelect.dirty || scheduleUserSelect.touched)}">
                    <option *ngFor="let userInfo of userInfoArray" [ngValue]="userInfo.id">{{userInfo.name}}</option>
                </select>
                <span *ngIf="scheduleUserSelect.invalid" class="text-danger small font-italic">* Required</span>
            </div>
        </div>


        <div class="p-2">
            <label for="assignedUserSelect" class="form-label">Assigned Tester:</label>
            <select name="assignedUser" class="form-control" id="assignedUserSelect"
                [(ngModel)]="tmpPathTest.assignments.testUserId" #assignedUserSelect="ngModel" required
                [ngClass]="{ 'invalid-input': assignedUserSelect.invalid && (assignedUserSelect.dirty || assignedUserSelect.touched)}">
                <option *ngFor="let userInfo of userInfoArray" [ngValue]="userInfo.id">{{userInfo.name}}</option>
            </select>
            <span *ngIf="assignedUserSelect.invalid" class="text-danger small font-italic">* Required</span>
        </div>

        <div class="p-2">
            <span class="gray font-italic pl-2">Access Procedures/Notes</span>
            <textarea name="schedule.scheduleNotes" [(ngModel)]="tmpPathTest.schedule.scheduleNotes" rows="4" class="w-100"
                style="resize: none" #scheduleNotes="ngModel"
            [ngClass]="{ 'invalid-input': scheduleNotes.invalid && (scheduleNotes.dirty || scheduleNotes.touched)}"></textarea>
        </div>

    </form>
    <div class="card p-2 mt-3" *ngIf="_pathTestDoc.type === 'path test'">
        <div class="p-2">
            <div class="d-flex flex-row card-title justify-content-between">
                <div>Test Points:</div>
                <button *ngIf="!bLoadingPointIds && pointIds?.length; loadingPointIds" (click)="randomizePoints()"
                    class="btn btn-secondary btn-sm">Randomize</button>
                <ng-template #loadingPointIds>
                    <i class="fa fa-spinner fa-spin"></i>
                </ng-template>
            </div>
            <ng-container *ngIf="!bLoadingPointIds && !pointIds?.length">
                <div *ngIf="tmpPathTest.pathId; else selectPathId" class="small text-danger font-italic">
                    No points found for path {{tmpPathTest.pathId}}
                </div>
                <ng-template #selectPathId>
                    <div class="small text-muted font-italic">* Please select a Path ID</div>
                </ng-template>
            </ng-container>
            <ng-container *ngFor="let pointId of pointIds; index as index;">
                <div *ngIf="scoutPointByPointId[pointId]?.disabled; else notDisabledScoutPoint"
                class="badge m-1 bg-warning"
                style="text-decoration: line-through;opacity: 0.5;"
                title="Scout point source is disabled (cannot use)">
                    #{{index+1}}: {{pointId}}
                </div>
                <ng-template #notDisabledScoutPoint>
                <div  class="badge m-1"
                        [attr.role]="canToggleByStatusId[statusByPointId[pointId]]?'button':''"
                        [ngClass]="statusByPointId[pointId]|taskStatusCss"
                        (click)="toggleNotUsing(pointId)">
                    #{{index+1}}: {{pointId}}
                </div>
                </ng-template>
            </ng-container>
        </div>
    </div>
</div>

<div class="modal-footer">
    <div class="d-flex flex-row justify-content-between w-100">
        <div>
            <div *ngIf="bNoWaypointsFound" class="text-warning font-italic small">
                No waypoints defined in database for path.
            </div>
        </div>
        <div>
            <div class="btn-group" dropdown
                [isDisabled]="bProcessing || bLoadingPointIds">
                <button [disabled]="bProcessing || bLoadingPointIds || !pathTestForm.dirty || pathTestForm.invalid"
                        (click)="onSave()" class="btn btn-primary">
                    Save
                </button>
                <ng-container *ngIf="pathTestDoc?._id">
                    <button id="actions-btn-split" dropdownToggle
                            class="btn btn-secondary dropdown-toggle dropdown-toggle-split"
                            aria-controls="actions-dropdown-split">
                        <span class="caret"></span>
                        <span class="sr-only visually-hidden">Additional Actions</span>
                    </button>
                    <div id="actions-dropdown-split" *dropdownMenu class="dropdown-menu px-1 py-0 pb-1 m-0"
                            role="menu" aria-labelledby="actions-btn-split">
                        <button [disabled]="(bProcessing || bLoadingPointIds) || (!pathTestDoc || !pathTestDoc._id)"
                            (click)="onDelete()" class="btn btn-warning">
                        <i class="fa fa-times-circle text-danger mr-1"></i>Delete Path Test
                        </button>
                        <button *ngIf="!!this.pathTestDoc._id" [disabled]="bProcessing || (!pathTestDoc || !pathTestDoc._id)"
                            (click)="confirmRandomizePathTests()" class="btn btn-secondary">
                            Randomize Path Tests
                        </button>
                    </div>
                </ng-container>
            </div>
            &nbsp;
            <button (click)="onCancel()" class="btn btn-secondary">
                Cancel
            </button>
        </div>
    </div>
</div>
</div>